var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientTab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1693 14V12.6667C11.1693 11.9594 10.8883 11.2811 10.3882 10.781C9.88813 10.281 9.20985 10 8.5026 10H4.5026C3.79536 10 3.11708 10.281 2.61699 10.781C2.11689 11.2811 1.83594 11.9594 1.83594 12.6667V14",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5026 7.33333C7.97536 7.33333 9.16927 6.13943 9.16927 4.66667C9.16927 3.19391 7.97536 2 6.5026 2C5.02984 2 3.83594 3.19391 3.83594 4.66667C3.83594 6.13943 5.02984 7.33333 6.5026 7.33333Z",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1641 13.9998V12.6664C15.1636 12.0756 14.967 11.5016 14.605 11.0346C14.243 10.5677 13.7361 10.2341 13.1641 10.0864",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1641 2.08643C11.7377 2.23329 12.2461 2.56689 12.6092 3.03463C12.9722 3.50237 13.1693 4.07765 13.1693 4.66976C13.1693 5.26187 12.9722 5.83715 12.6092 6.30489C12.2461 6.77262 11.7377 7.10623 11.1641 7.25309",
    stroke: "#333333",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientTab);
export default __webpack_public_path__ + "static/media/client_tab.49fc58813cde8265146407a5ce499b7f.svg";
export { ForwardRef as ReactComponent };